export default {
	'auto updated': 'auto update',
	added: 'add',
	applied: 'apply',
	changed: 'change',
	clicked: 'click',
	collapsed: 'collapse',
	completed: 'complete',
	displayed: 'display',
	expanded: 'expand',
	impression: 'view',
	navigated: 'navigate',
	opened: 'open',
	received: 'receive',
	removed: 'remove',
	saved: 'save',
	selected: 'select',
	submitted: 'submit',
	swiped: 'swipe',
	updated: 'update',
	viewed: 'view'
};
